import * as React from "react";
import { InvoiceItemType } from "@graffer-inc/cloud-gov-core";
import { PaymentItemLine } from "./payment-item-line";

export type PaymentItemTableProps = {
  invoice: {
    items: (InvoiceItemType & {
      createdAt?: Date;
      operationIndex?: number;
    })[];
  };
  isShowDate?: boolean;
};

export const PaymentItemTable: React.FC<PaymentItemTableProps> = ({
  invoice,
  isShowDate,
}) => {
  return (
    <table className="table is-fullwidth is-marginless c-border">
      <thead>
        <tr>
          {isShowDate && <th style={{ width: "25%" }}>日時</th>}
          <th>費目</th>
          <th className="has-text-right">金額</th>
        </tr>
      </thead>
      <tbody>
        {invoice.items.map((v, idx) => (
          <PaymentItemLine
            isShowDate={isShowDate}
            item={v}
            key={`${invoice.items.length}-${idx}`}
          />
        ))}
      </tbody>
    </table>
  );
};
